import React from "react";

export default function RequirementsAcknowledgedIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <rect
        x="1"
        y="1"
        width="8"
        height="11"
        rx="1.2"
        stroke="currentColor"
        strokeWidth="1.1"
      />
      <line
        x1="2.8"
        y1="3.8"
        x2="7"
        y2="3.8"
        stroke="currentColor"
        strokeWidth="1"
      />
      <line
        x1="2.8"
        y1="6"
        x2="6.5"
        y2="6"
        stroke="currentColor"
        strokeWidth="1"
      />
      <circle
        cx="10.3"
        cy="10.3"
        r="3.1"
        stroke="currentColor"
        strokeWidth="1.1"
      />
      <path
        d="M8.9 10.3 L9.7 11.1 L11.5 9.1"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
